export const AVATAR_PLACEHOLDER_URL = 'https://s3.eu-north-1.amazonaws.com/cdn.no-gravity.es/dashboard/avatar-placeholder.png';
